import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Competition } from '../../models/competition';
import { Person } from '../../models/person';
import { I_competition_entry } from '../../models/i_competition_entry.interface';
import { faCheck, faTrash, faTimes } from '@fortawesome/fontawesome-pro-regular';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-modal-choose-competition',
  templateUrl: './modal-choose-competition.component.html',
  styleUrls: ['./modal-choose-competition.component.css']
})
export class ModalChooseCompetitionComponent extends SmsAbstractAppPage implements OnInit {

  faCheck = faCheck;
  faTrash = faTrash;
  faTimes = faTimes;

  @Input() competition_list: Competition[];
  @Input() riders: Person[] = [];
  @Input() selected_rider: Person;
  @Input() pending_competition_entry_list: I_competition_entry[] = [];

  entire_competition_list: Competition[];
  filter_text: string = '';

  @Output() competition_selected$: EventEmitter<Competition> = new EventEmitter<Competition>();
  @Output() competition_removed$: EventEmitter<Competition> = new EventEmitter<Competition>();

  public selected_competition_map: Map<string, Competition> = new Map<string, Competition>();

  constructor(public activeModal: NgbActiveModal) {
    super();
  }

  ngOnInit() {
    this.entire_competition_list = this.competition_list;

    // Pre-populate from competitions already on the entry
    this.pending_competition_entry_list
      .filter(e => !e.is_section_entry)
      .forEach(e => {
        const comp = this.entire_competition_list.find(c => c.id === e.competition_id);
        if (comp) this.selected_competition_map.set(comp.id, comp);
      });
  }

  get total_count(): number {
    return this.entire_competition_list?.length ?? 0;
  }

  get selected_count(): number {
    return this.selected_competition_map.size;
  }

  handleSelectCompetition(competition: Competition) {
    this.selected_competition_map.set(competition.id, competition);
    this.competition_selected$.emit(competition);
  }

  handleUnSelectCompetition(competition: Competition) {
    this.selected_competition_map.delete(competition.id);
    this.competition_removed$.emit(competition);
  }

  toggleCompetition(competition: Competition) {
    if (this.selected_competition_map.has(competition.id)) {
      this.handleUnSelectCompetition(competition);
    } else {
      this.handleSelectCompetition(competition);
    }
  }

  handleFilterCompetitions(filterText: string) {
    this.filter_text = filterText;

    if (!filterText) {
      this.competition_list = this.entire_competition_list;
      return;
    }

    const term = filterText.toLowerCase();
    const seen = new Set<string>();
    const result: Competition[] = [];

    // First pass: name starts-with (highest relevance)
    this.entire_competition_list.forEach(competition => {
      if (competition.name.toLowerCase().startsWith(term) && !seen.has(competition.id)) {
        result.push(competition);
        seen.add(competition.id);
      }
    });

    // Second pass: name contains or number matches
    this.entire_competition_list.forEach(competition => {
      const matchesName = competition.name.toLowerCase().includes(term);
      const matchesNumber = String(competition.number).includes(term);
      if ((matchesName || matchesNumber) && !seen.has(competition.id)) {
        result.push(competition);
        seen.add(competition.id);
      }
    });

    this.competition_list = result;
  }

  clearFilter() {
    this.filter_text = '';
    this.competition_list = this.entire_competition_list;
  }

  // Select the first visible result on Enter from the filter input
  handleEnterKey() {
    if (this.competition_list.length > 0 && !this.selected_competition_map.has(this.competition_list[0].id)) {
      this.handleSelectCompetition(this.competition_list[0]);
    }
  }
}
